import { CalendarIcon } from './CalendarIcon';

/**
 * author: Google
 * id 23C8742A-612C-4C55-B184-2A0ABB387746
 * name calendar
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar.svg
 * tags
 * - Date / Time 
 */
export const InsertInvitationIcon = CalendarIcon;
export default InsertInvitationIcon